import { GuideSummary } from '../types/guides'

const slugPattern = /^[a-z0-9]+(?:-[a-z0-9]+)*$/
const datePattern = /^\d{4}-\d{2}-\d{2}$/
const guidePathPattern = /^\/guides\/([a-z0-9]+(?:-[a-z0-9]+)*)\/$/

const isRecord = (value: unknown): value is Record<string, unknown> => {
  return typeof value === 'object' && value !== null
}

const isValidDate = (value: string) => {
  if (!datePattern.test(value)) return false
  const [year, month, day] = value.split('-').map(Number)
  const date = new Date(Date.UTC(year, month - 1, day))
  return date.getUTCFullYear() === year && date.getUTCMonth() === month - 1 && date.getUTCDate() === day
}

export const parseGuideSummary = (value: unknown): GuideSummary => {
  if (!isRecord(value)) throw new Error('资料列表格式无效')

  const strings = ['slug', 'title', 'summary', 'category', 'date', 'path']
  if (strings.some(field => typeof value[field] !== 'string' || value[field].trim() === '')) {
    throw new Error('资料列表格式无效')
  }

  const slug = value.slug as string
  const guidePath = value.path as string
  const pathMatch = guidePath.match(guidePathPattern)
  if (!slugPattern.test(slug) || !pathMatch || pathMatch[1] !== slug || !isValidDate(value.date as string)) {
    throw new Error('资料列表格式无效')
  }

  if (value.cover !== undefined && (typeof value.cover !== 'string' || !value.cover.startsWith(`${guidePath}`))) {
    throw new Error('资料列表格式无效')
  }
  if (value.featured !== undefined && typeof value.featured !== 'boolean') {
    throw new Error('资料列表格式无效')
  }

  return {
    slug,
    title: value.title as string,
    summary: value.summary as string,
    category: value.category as string,
    date: value.date as string,
    path: guidePath,
    ...(value.cover ? { cover: value.cover as string } : {}),
    ...(value.featured !== undefined ? { featured: value.featured as boolean } : {})
  }
}

export const loadGuides = async (fetcher: typeof fetch = globalThis.fetch): Promise<GuideSummary[]> => {
  try {
    const response = await fetcher('/guides/manifest.json')
    if (!response.ok) throw new Error('资料列表暂时无法加载')
    const value: unknown = await response.json()
    if (!Array.isArray(value)) throw new Error('资料列表格式无效')
    return value.map(parseGuideSummary)
  } catch (error) {
    if (error instanceof Error && (error.message === '资料列表暂时无法加载' || error.message === '资料列表格式无效')) {
      throw error
    }
    throw new Error('资料列表暂时无法加载')
  }
}
